"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const node_html_parser_1 = __importStar(require("node-html-parser"));
function replaceFill(svg, color) {
    // skip dom parsing if possible, return HTMLElement object in that case
    if (svg instanceof node_html_parser_1.HTMLElement)
        return recursiveRecolor(svg, color);
    return recursiveRecolor((0, node_html_parser_1.default)(svg), color).toString();
}
// replace the fill and stroke colors on all child
// elements of the SVG; but only if those elements
// already have a fill or stroke set, recursively
// traversing nested SVG elements.
const recursiveRecolor = (dom, color) => {
    // this uses node-html-parser instead of native DOM
    // so that it will support server-side-rendering.
    // const svgElement = svgDom.querySelector('svg')!
    const children = dom.childNodes;
    if (children)
        for (const child of children) {
            // note this is the node-html-parser implementation
            // of the HTMLElement class, not a native HTMLElement
            if (child instanceof node_html_parser_1.HTMLElement) {
                // recursive call handles nested SVG structures like groups
                if (child.childNodes && child.childNodes.length > 0)
                    recursiveRecolor(child, color);
                if (child.hasAttribute('fill'))
                    child.setAttribute('fill', color);
                if (child.hasAttribute('stroke'))
                    child.setAttribute('stroke', color);
            }
        }
    return dom;
};
exports.default = replaceFill;
//# sourceMappingURL=replaceFill.js.map